import "./Home.css";
import "../App.css";
import { navItems } from "./Nav";
import { useEffect, useState, useRef } from "react";
import Typewriter from "typewriter-effect"; // React-friendly Typewriter effect
import TypewriterCore from "typewriter-effect/dist/core"; // For custom logic

console.log(navItems);

const Home = () => {
  document.title = "Xinyi Wen";

  // References for the dynamic word container for desktop and mobile
  const desktopDynamicWordRef = useRef(null);
  const [desktopDynamicWordsReady, setDesktopDynamicWordsReady] = useState(false);
  const mobileDynamicWordRef = useRef(null);
  const [mobileDynamicWordsReady, setMobileDynamicWordsReady] = useState(false);


  // Reusable function to handle dynamic typing animation
  const startTypewriter = (ref) => {
    const typewriter = new TypewriterCore(ref, {
      loop: true,
      delay: 70,
      deleteSpeed: 50,
    });

    // Words for dynamic typing
    const words = [
        "Photography",
        "Art & Design",
        "Formulas",
        "Data",
        // "Cooking",
    ];

    words.forEach((word) => {
      typewriter
        .typeString(word + ".")
        .pauseFor(1800)
        .deleteAll();
    });

    typewriter.start();
  };

  // useEffect for Desktop Dynamic Word Animation
  useEffect(() => {
    if (desktopDynamicWordsReady && desktopDynamicWordRef.current) {
      startTypewriter(desktopDynamicWordRef.current);
    }
  }, [desktopDynamicWordsReady]); // Trigger when desktop dynamic words are ready

  // useEffect for Mobile Dynamic Word Animation
  useEffect(() => {
    if (mobileDynamicWordsReady && mobileDynamicWordRef.current) {
      startTypewriter(mobileDynamicWordRef.current);
    }
  }, [mobileDynamicWordsReady]); // Trigger when mobile dynamic words are ready

  return (
    <>
      <main className="wrapper">
        <div className="content">
          <h1 className="home">Hello World!</h1>
          <div className="home">
            <div className="home-line">
              {/* First Part: Static Typing Effect for Desktop */}
              <Typewriter
                options={{
                  loop: false, // Only runs once
                  delay: 60,
                }}
                onInit={(typewriter) => {
                  typewriter
                    .pauseFor(1000)
                    .typeString("I am Xinyi, ")
                    .pauseFor(200)
                    .typeString("an AI student interested in")
                    .callFunction(() => {
                      // Hide the cursor when typing is done for desktop
                      const cursorElement = document.querySelector(".Typewriter__cursor");
                      if (cursorElement) {
                        cursorElement.style.display = "none";
                      }
                      setDesktopDynamicWordsReady(true); // Enable desktop dynamic word animation
                    })
                    .start();
                }}
              />
              {/* Dynamic Word Animation for Desktop */}
              <span
                id="desktop-dynamic-word"
                ref={desktopDynamicWordRef}
                style={{
                  display: "inline-block",
                  marginLeft: "0.25em",
                  width: "7em", // Adjust width to fit longest word
                  textAlign: "left",
                  verticalAlign: "middle",
                }}
              ></span>
            </div>
          </div>
        </div>

        {/* Mobile Version */}
        <div className="content-mobile">
          <h1 className="home">Hello,</h1>
          <h1 className="home">World!</h1>
          <div className="home">
            {/* Static Typing Effect for Mobile */}
            <Typewriter
              options={{
                loop: false,
                delay: 60,
              }}
              onInit={(typewriter) => {
                typewriter
                  .pauseFor(1000)
                  .typeString("I am Xinyi, ")
                  .pauseFor(200)
                  .typeString("an <br/>AI student interested in")
                  .callFunction(() => {
                    const cursorElement = document.querySelectorAll(".Typewriter__cursor")[2];
                      if (cursorElement) {
                        cursorElement.style.display = "none";
                      }
                    setMobileDynamicWordsReady(true); // Enable mobile dynamic word animation
                  })
                  .start();
              }}
            />
            {/* Dynamic Word Animation for Mobile */}
            <span
              id="mobile-dynamic-word"
              ref={mobileDynamicWordRef}
            ></span>
          </div>
        </div>

        {/* Navigation Buttons */}
        <div className="icons-container" id="home-nav-container">
          {
            navItems.map((item) => {
              return (
                <div className="button-block">
                  <a className="button" href={item.path}>
                    <img className="icon" src={"img/" + item.title.toLowerCase() + ".svg"} alt={item.title} />
                    <p>{item.title.toUpperCase()}</p>
                  </a>
                </div>
              )
            })
          }
        </div>
      </main>

      <footer>© 2025 | Xinyi Wen</footer>
    </>
  );
};

export default Home;
